<template>
  <div>
    <div
      class="floated-chat-btn"
      data-target="#entarimarModal"
      data-toggle="modal"
      @click="refreshMotivoDevolucion()"
      style="z-index: 1000 !important"
    >
      <i class="fas fa-check"></i>&nbsp;&nbsp;Entarimar
    </div>
    <div
      class="modal fade"
      id="entarimarModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Entarimar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 row">
                <div class="col-10">
                  <div class="form-group">
                    <label for>Tarima</label>
                    <input
                      class="form-control"
                      placeholder="Tarima"
                      type="text"
                      autocomplete="off"
                      v-model="current.tarima_barra"
                    />
                    <small class="form-text text-danger" v-if="errors">{{
                      errors.tarima_barra
                    }}</small>
                  </div>
                </div>
                <div class="col-1">
                  <br />
                  <button @click="Imprimir()" class="btn btn-info btn-lg">
                    <i class="fas fa-print"></i>
                  </button>
                </div>
              </div>
              <h6 style="color: blue" v-if="current && current.producto">
                {{ current.producto.sku }}
                {{ current.producto.nombre }}
              </h6>
              <small v-if="errors" class="form-text text-danger">{{
                errors.producto
              }}</small>
              <div class="col-md-12">
                <div class="form-group">
                  <label for>Producto</label>
                  <input
                    v-on:keyup.enter="refreshProducto(current.barra)"
                    class="form-control"
                    placeholder="Producto"
                    type="text"
                    autocomplete="off"
                    v-model="current.barra"
                  />
                  <small class="form-text text-danger" v-if="errors">{{
                    errors.producto
                  }}</small>
                </div>
              </div>
              <div class="col-sm-12">
                <button
                  @click="refreshProducto(current.barra)"
                  class="btn btn-sm btn-info btn-block"
                >
                  Buscar
                </button>
                &nbsp;
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for>Motivo Devolución</label>
                  <select v-model="current.motivo" class="form-control">
                    <option :value="null">SIN MOTIVO DEVOLUCIÓN</option>
                    <option v-for="(c, key) in tipo_motivo" :value="c.id" :key="key">
                      {{ c.descripcion }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label for>Cantidad</label>
                  <input
                    class="form-control"
                    placeholder="Cantidad"
                    type="number"
                    autocomplete="off"
                    step="0.01"
                    v-model="current.cantidad"
                  />
                  <small class="form-text text-danger" v-if="errors">{{
                    errors.cantidad
                  }}</small>
                </div>
              </div>
            </div>
            <small v-if="error_entarimar" class="form-text text-danger">{{
              error_entarimar
            }}</small>
          </div>
          <div class="modal-footer">
            <button class="btn btn-block btn-primary" type="button" @click="entarimar">
              Entarimar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  props: {
    tarima: {
      type: Object,
    },
  },
  data() {
    return {
      current: {
        producto: "",
        motivo: "",
        tipo: "D",
        error_entarimar: "",
        barra: null,
        tarima_barra: null,
        cantidad: null,
        tipo_motivo: "",
        errors: "",
        null: null,
        motivo: null,
      },
      producto: "",
      motivo: "",
      tipo: "D",
      error_entarimar: "",
      barra: null,
      tarima_barra: null,
      cantidad: null,
      tipo_motivo: "",
      errors: {
        producto: "",
      },
      null: null,
      motivo: null,
    };
  },
  mounted() {
    let self = this;
  },
  methods: {
    Imprimir() {
      let self = this;
      self.id = self.tarima.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/tarima.jrxml&id=${self.id}`
      );
    },
    resetDataProducto() {
      this.producto = [];
      this.errors = [];
    },
    refreshMotivoDevolucion() {
      let self = this;
      DynamicService.fetch("inv", "motivo_devolucion").then((response) => {
        self.tipo_motivo = response.data.results;
      });
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        self.errors.producto = "Este campo no puede ser nulo";
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          self.current.producto = response.data.results[0].producto_obj;
          self.errors.producto = "";
        })
        .catch((err) => {
          self.current.producto = null;
          self.errors.producto = "No existe producto";
        });
    },
    cleanDataBefore() {
      let self = this;
      self.errors.producto = "";
      self.error_entarimar = null;
      self.current.barra = null;
      self.current.tarima_barra = null;
      self.current.cantidad = null;
      self.current.motivo = null;
      self.current.producto = null;
    },
    entarimar() {
      let self = this;
      if (!self.current.producto || self.current.producto == null) {
        Notifications.alert.error("Producto", "No existe este produco");
        return;
      }
      if (self.current.producto) {
        self.current.producto_barra = self.current.producto.sku;
      }
      if (self.current.motivo == null) {
        delete self.current.motivo;
      }
      DynamicService.postAction(
        "wms",
        "tarima",
        self.tarima.id,
        "agregar_producto_a_tarima_devolucion",
        self.current
      )
        .then((res) => {
          $("#entarimarModal").modal("hide");
          self.cleanDataBefore();
          self.$emit("refresh_tarima");
        })
        .catch((err) => {
          self.errors = err.response.data;
          Notifications.alert.error("Error", err.response.data.detail);
          if (err.response.data.detail) {
            self.error_entarimar = err.response.data.detail;
          }
        });
    },
  },
};
</script>
